module.exports = __webpack_public_path__ + "media/images/haircut/sabrina-207a4651c6254975da388aea6c73aa83.jpg";